export default (array, key, order) => {
    const sortOrder = order === 'asc' ? 1 : -1;

    return array.sort((a, b) => (a[key] > b[key]) ? sortOrder * 1 : sortOrder * -1);
}